import React, { useContext, useEffect, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import GoogleMapReact, { Coords } from 'google-map-react';
import { WebWidgetContext, WEB_WIDGET_ACTIONS } from '../context';
import AlertDetail from '../components/AlertDetail';
import { I18NContext } from '../common/I18N';

const InfoWindowContainer: React.FC<{ alert: any, title: string }> = ({ alert, title }) => {

  return (
    <div>
      <div className="powerby-logo">
        <div>{title}</div>
        <div>
          <i className="evbg-logo"></i>
        </div>
      </div>
      <AlertDetail alert={alert} isShowFullContent />
    </div>
  );
}

export default function WebWidgeMapView() {

  const {
    actionDispatch,
    state: {
      mapCenter,
      googleMapAPIKey,
      selectedAlert,
      polygonUtils,
    }
  } = useContext(WebWidgetContext);

  const i18n: any = useContext(I18NContext);

  const defaultCenter = {
    lat: mapCenter.lat,
    lng: mapCenter.lon,
  };

  const [center, updateCenter] = useState<Coords>(defaultCenter);

  const [currentSelectedAlert, updateCurrentSelectedAlert] = useState(selectedAlert);

  const calculatePolygonPoints = (shapes: Array<any>) => shapes.map(item => item.shape.points.map((point: { y: number; x: number; }) => ({ lat: point.y, lng: point.x })))

  const handleApiLoaded = (map: any, mapApi: any) => {
    // use map and maps objects
    console.log('map:', map)
    console.log('mapApi:', mapApi)
    actionDispatch(WEB_WIDGET_ACTIONS.GOOGLE_MAP_LOADED, { google: mapApi, map: map });
  };

  const [infoWindowContent, setInfoWindowContent] = useState('');

  useEffect(() => {
    updateCenter({
      lat: mapCenter.lat,
      lng: mapCenter.lon,
    })
  }, [mapCenter]);

  useEffect(() => {
    if (selectedAlert) {
      setInfoWindowContent(ReactDOMServer.renderToString(<InfoWindowContainer title={i18n.get('web.widget.powered.by')} alert={selectedAlert} />));
      if (currentSelectedAlert) {
        polygonUtils.cleanPolygon(currentSelectedAlert.notificationId);
      }
      updateCurrentSelectedAlert(selectedAlert);
    }
  }, [selectedAlert]);

  useEffect(() => {
    if (polygonUtils && currentSelectedAlert && currentSelectedAlert.hasPolygon) {
      console.log('current selected alert: ', currentSelectedAlert);
      const points = calculatePolygonPoints(currentSelectedAlert.polygon);
      console.log('polygon points: ', points)
      console.log('polygonUtils:', polygonUtils)
      polygonUtils.renderPolygon(selectedAlert.notificationId, {
        paths: points,
      }, infoWindowContent);

      // updateCenter(points[0][0])
      polygonUtils.fitBoundsAndPanTo(points);
    }
  }, [currentSelectedAlert, polygonUtils]);

  return (
    <GoogleMapReact
      bootstrapURLKeys={{ key: googleMapAPIKey }}
      defaultCenter={defaultCenter}
      center={center}
      defaultZoom={mapCenter.zoom}
      yesIWantToUseGoogleMapApiInternals
      onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
    >
    </GoogleMapReact>
  )
}